import { motion } from "framer-motion";
import { Lightbulb, CalendarClock, MessagesSquare } from "lucide-react";
import { IMAGES } from "../data";

const STEPS = [
  {
    icon: Lightbulb,
    title: "Creative Solutions",
    desc: "From clever storage ideas to full room transformations, I help shape your idea into a real plan.",
  },
  {
    icon: CalendarClock,
    title: "Flexible Planning",
    desc: "Scheduling that works around your life, with clear timelines and no surprises.",
  },
  {
    icon: MessagesSquare,
    title: "Clear Communication",
    desc: "Honest updates from first chat to final finish — you always know where things stand.",
  },
];

export const Vision = () => {
  return (
    <section id="vision" data-testid="vision-section" className="relative py-20 sm:py-28 overflow-hidden bg-brand-brown grain">
      <div className="absolute inset-0 opacity-20">
        <img src={IMAGES.tools} alt="" className="w-full h-full object-cover" />
      </div>
      <div className="relative z-10 max-w-7xl mx-auto px-5 sm:px-8">
        <div className="max-w-2xl">
          <p className="text-brand-olive font-semibold tracking-widest uppercase text-sm mb-3">
            Your Vision, Built Together
          </p>
          <h2 className="font-display font-extrabold text-[#FCFAF6] text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-tight">
            Every home has a dream. I help you build it.
          </h2>
          <p className="mt-4 text-[#EDE6DA]/85 text-base sm:text-lg leading-relaxed">
            Every customer has a vision for their space — and I work with you to
            make it happen, with a perfectionist&apos;s eye and the skills to
            back it up.
          </p>
        </div>

        <div className="mt-14 grid md:grid-cols-3 gap-6">
          {STEPS.map((s, i) => (
            <motion.div
              key={s.title}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.1 }}
              data-testid={`vision-step-${i}`}
              className="rounded-2xl bg-white/5 backdrop-blur border border-white/10 p-7 hover:bg-white/10 transition-colors"
            >
              <div className="w-12 h-12 rounded-xl bg-brand-olive flex items-center justify-center text-brand-bg mb-5">
                <s.icon size={24} />
              </div>
              <h3 className="font-display font-bold text-xl text-[#FCFAF6]">{s.title}</h3>
              <p className="mt-2 text-[#EDE6DA]/75 text-sm leading-relaxed">{s.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
